<button class="account-btn">
  <div class="account-avatar">
    <img class="avatar avatar--hover" src="{{avatar}}" alt="Пользователь: {{firstName}} {{secondName}}" width="45"
      height="45">
  </div>
  <span class="account-title">Hey, {{firstName}} !</span>
</button>